module.exports = __webpack_public_path__ + "img/_ABS9725(1).931c318e.jpg";